/**
 * @generated SignedSource<<42c6c913007d718dc6b8734b3d3b535c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleFocusScreenColumn_teamSchedule$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule" | "WidgetTeamScheduleContentSectionHeader_teamSchedule" | "WidgetTeamScheduleContentStatus_teamSchedule">;
  readonly " $fragmentType": "TeamScheduleFocusScreenColumn_teamSchedule";
};
export type TeamScheduleFocusScreenColumn_teamSchedule$key = {
  readonly " $data"?: TeamScheduleFocusScreenColumn_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreenColumn_teamSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleFocusScreenColumn_teamSchedule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleContentList_teamSchedule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleContentStatus_teamSchedule"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};

(node as any).hash = "f18175b02e3ed611b33301ad78d99e36";

export default node;
